import { createApp } from 'vue'
import App from './App.vue'
import { createVuetify } from 'vuetify'
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { ru } from 'vuetify/locale'
import router from './router'
import HighlightRequired from './assets/HighlightRequired'
import store from './store'
import VueTheMask from 'vue-the-mask'
import { applyThemeToDocument, getInitialTheme } from './utils/theme'

const observerErr = window.console.error
window.console.error = (...args) => {
  if (args[0]?.includes?.('ResizeObserver loop completed')) return
  observerErr(...args)
}

const initialTheme = getInitialTheme()
applyThemeToDocument(initialTheme)

const vuetify = createVuetify({
    directives,
    components,
    theme: {
        defaultTheme: initialTheme,
        themes: {
            light: {
                dark: false,
                colors: {
                    background: '#f4f6f9',
                    surface: '#fbfcfe',
                    'surface-bright': '#fbfcfe',
                    'surface-light': '#eef2f7',
                    'surface-variant': '#e4e9f1',
                    'on-surface-variant': '#475569',
                    primary: '#315f9b',
                    secondary: '#3b8179',
                    error: '#b53d4b',
                    info: '#3478b8',
                    success: '#2f7d50',
                    warning: '#a26716',
                }
            },
            dark: {
                dark: true,
                colors: {
                    background: '#151b23',
                    surface: '#1d2632',
                    'surface-bright': '#2a3645',
                    'surface-light': '#253140',
                    'surface-variant': '#2a3645',
                    'on-surface-variant': '#c0cad8',
                    primary: '#89aefb',
                    secondary: '#55c2b4',
                    error: '#ff7b86',
                    info: '#69b7ff',
                    success: '#67c58b',
                    warning: '#f4c46c',
                }
            }
        }
    },
    locale: {
        locale: 'ru',
        fallback: 'ru',
        messages: { ru }
    }
})

createApp(App)
.directive('HighlightRequired', HighlightRequired)
.use(store)
.use(router)
.use(vuetify)
.use(VueTheMask)
.mount('#app')

store.dispatch('fetchConfig')
